import module from 'recursoshumanos/module.js'
import template from './template.html'

export class RecursoshumanosReportesRetencionInfonavitDescargaComponent {
  operadoraId
  operadora
  inicio
  final
  onClose

  constructor (RecursoshumanosReportesRetencionInfonavitService) {
    this.RecursoshumanosReportesRetencionInfonavitService = RecursoshumanosReportesRetencionInfonavitService
  }

  exportarXLS () {
    if (this.descargando) return

    this.descargando = true

    this.RecursoshumanosReportesRetencionInfonavitService.get(this.operadoraId, this.inicio, this.final, `Reporte retención infonavit de ${this.operadora}`)
      .then((response) => {
        this.descargado = true
        this.descarga = response
      })
      .catch((responso) => (this.error = responso.data))
      .finally(() => this.descargando = false)
  }

  descargar () {
    this.descarga.data.save()
  }

  cerrar () {
    this.onClose()
  }
}

module.component('recursoshumanosReportesRetencionInfonavitDescarga', {
  controller: RecursoshumanosReportesRetencionInfonavitDescargaComponent,
  template,
  bindings: {
    operadoraId: '<',
    operadora: '<',
    inicio: '<',
    final: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/recursoshumanos/components/reportes/retencion/infonavit/descarga/component.js